import lodashGet from "lodash/get";
import { make } from "vuex-pathify";
import loader from "@/util/loader";
import api from "@/util/api";

const initialState = {
    dealerHours: {
        data: null,
        loader: loader.defaultState(),
    },
};

const mutations = {
    ...make.mutations(initialState),

    SET_DEALER_HOURS: (state, payload) => {
        state.dealerHours.data = payload.data;
        state.dealerHours.loader = payload.loader;
    },
};

const actions = {
    fetchDealerHours({ commit, state }, { dealerId }) {
        commit("SET_DEALER_HOURS", {
            data: null,
            loader: loader.started(),
        });

        return api
            .get(`/dealer/${dealerId}/dealer-hours`)
            .then((response) => {
                commit("SET_DEALER_HOURS", {
                    data: lodashGet(response, "data", null),
                    loader: loader.successful(),
                });
            })
            .catch((error) => {
                console.log(error);
                commit("SET_DEALER_HOURS", {
                    data: null,
                    loader: loader.error(error),
                });
            });
    },
};

export default {
    namespaced: true,
    state: initialState,
    actions,
    mutations,
};
